<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="请选择钻井"
    style="width: 100%"
    :disabled="disabled"
    filterable
  >
    <el-option v-if="clearable" :key="0" label="不限" :value="0"></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.well_number"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { drillWellList } from '@/service/getData'

export default {
  props: {
    value: '',
    baseid: {
      type: Number,
      default: 0,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    authLimit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },

  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await drillWellList({
        base_id: this.baseid,
        auth_limit: this.authLimit,
        size: 100,
      })
      if (res.status == 0) {
        this.lists = res.data.list
      }
    },
    handleChange(e) {
      this.$emit('input', e)
      this.$emit(
        'info',
        this.lists.find((item) => item.id == e),
      )
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>